"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M15.351 7.8h-1.77V6.6H17.4v3.818h-1.2v-1.77l-3.803 3.803-.849-.848L15.351 7.8z" }),
    React.createElement("path", { d: "M8.41 7.855a.61.61 0 00-.61.61v7.125c0 .337.273.61.61.61h7.125a.61.61 0 00.61-.61v-3.563h1.2v3.563c0 1-.81 1.81-1.81 1.81H8.41c-1 0-1.81-.81-1.81-1.81V8.465c0-1 .81-1.81 1.81-1.81h3.563v1.2H8.41z" })), "ExternalLink");
//# sourceMappingURL=ExternalLink.js.map